import { MapPin, Phone, Mail } from "lucide-react";

export function ContactInfo() {
  return (
    <div className="lg:col-span-1 space-y-8">
      <div>
        <h2 className="text-xl font-semibold text-slate-900 font-['Outfit'] mb-6">
          Get In Touch
        </h2>
        <p className="text-slate-600 mb-8 font-['Plus_Jakarta_Sans']">
          If you have any questions, please do not hesitate to send us a message. 
          We aim to reply within 24 hours.
        </p>
      </div>
      
      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-blue-100 flex items-center justify-center flex-shrink-0">
            <MapPin className="w-5 h-5 text-blue-700" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">USA Office</h3>
            <p className="text-slate-600 text-sm">
              5465 Legacy Drive, Suite 650<br />
              Plano, TX 75024 USA
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-blue-100 flex items-center justify-center flex-shrink-0">
            <MapPin className="w-5 h-5 text-blue-700" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">New Delhi Office</h3>
            <p className="text-slate-600 text-sm">
              L4, Chittranjan Park<br />
              New Delhi - 110019, India
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-blue-100 flex items-center justify-center flex-shrink-0">
            <MapPin className="w-5 h-5 text-blue-700" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">Gurgaon Office</h3>
            <p className="text-slate-600 text-sm">
              NS 02, Unitech Uniworld Resort<br />
              Sector 33, Gurugram, Haryana - 122004, India
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-blue-100 flex items-center justify-center flex-shrink-0">
            <Phone className="w-5 h-5 text-blue-700" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">Phone</h3>
            <a 
              href="tel:+16823317733" 
              className="text-slate-600 text-sm hover:text-blue-600 transition-colors"
            >
              (682) 331-7733
            </a>
          </div>
        </div>
        
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-blue-100 flex items-center justify-center flex-shrink-0">
            <Mail className="w-5 h-5 text-blue-700" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">Email</h3>
            <a 
              href="mailto:info@nidustechnologies.com" 
              className="text-slate-600 text-sm hover:text-blue-600 transition-colors"
            >
              info@nidustechnologies.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
